import { Color, PaneAmount, PaneItemChild, PaymentPaneProps } from '@billy/design-system'

import { InvoiceStatus } from '@features/invoicesLegacy/enums/invoiceStatus'
import { InvoicePaymentPaneExtra } from '@views/invoices/elements/InvoicePaymentPane/elements/InvoicePaymentPaneExtra'
import { InvoicePaymentPanePrefix } from '@views/invoices/elements/InvoicePaymentPane/elements/InvoicePaymentPanePrefix'

interface GetDemoInvoicePaymentPaneDataOptions {
  dueDate: Date
  grossTotal: number
}

export const getDemoInvoicePaymentPaneData = ({
  dueDate,
  grossTotal,
}: GetDemoInvoicePaymentPaneDataOptions): PaymentPaneProps => ({
  amount: (
    <PaneItemChild>
      <PaneAmount amount={grossTotal} color={Color.Red700} />
    </PaneItemChild>
  ),
  collapsible: false,
  extra: (
    <PaneItemChild>
      <InvoicePaymentPaneExtra date={dueDate.toISOString()} status={InvoiceStatus.Unpaid} />
    </PaneItemChild>
  ),
  icon: 'circleAlert',
  prefix: <InvoicePaymentPanePrefix status={InvoiceStatus.Unpaid} />,
})
